module.exports = {
  canvas: require('./canvas'),
  svg: require('./svg')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/node_modules/@antv/g/lib/renderers/index.js
// module id = 352
// module chunks = 0 1 2